import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import useApi from "../../hooks/useApi";
import { postConfirmAccount } from "../../services/authService";
import useLangNavigate from "../../hooks/useLangNavigate";
import useUserAgent from "../../hooks/useUserAgent";

function ConfirmAccount() {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const { activationCode } = useParams();
  const userAgent = useUserAgent();
  const { status, request: confirmAccountRequest } = useApi(postConfirmAccount);

  useEffect(() => {
    async function confirmAccount() {
      await confirmAccountRequest(activationCode)
        .then(() => {
          toast.success(t("confirmation.success"));
        })
        .catch((error) => {
          toast.error(error.message);
        });
    }
    confirmAccount();
  }, [activationCode, confirmAccountRequest, navigate, t]);

  // Auto-redirect after successful confirmation
  useEffect(() => {
    if (status === 200) {
      // Wait a moment to show the success message, then redirect
      const redirectTimer = setTimeout(() => {
        // Check if user is on mobile (Android or Apple)
        if (userAgent === "Android" || userAgent === "Apple") {
          // Redirect to mobile app
          window.location.href = "offood://";
        } else {
          // Redirect to login page on computer
          navigate("/login");
        }
      }, 2000); // 2 second delay to show success message

      return () => clearTimeout(redirectTimer);
    }
  }, [status, userAgent, navigate]);

  return (
    <div id="login">
      <div className="login-illustration" />
      <div className="login-content">
        <h4>{t("confirmation.title")}</h4>
        {status === 200 && <h5>{t("confirmation.successTitle")}</h5>}
        {status >= 300 && <h5>{t("confirmation.errorTitle")}</h5>}
      </div>
    </div>
  );
}

export default ConfirmAccount;
